'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(_ref) {
    var children = _ref.children,
        className = _ref.className,
        fluid = _ref.fluid,
        secondary = _ref.secondary,
        htmlFor = _ref.htmlFor,
        id = _ref.id,
        screenReader = _ref.screenReader;
    return secondary ? _react2.default.createElement("span", { className: 'luna-label__secondary', htmlFor: htmlFor, id: id }, children) : _react2.default.createElement("label", { className: (0, _classnames2.default)('luna-label', className, {
            'luna-label__fluid': fluid,
            'u-screenReader': screenReader
        }), htmlFor: htmlFor, id: id }, children);
};
Label.propTypes = {
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
    fluid: _propTypes2.default.bool,
    screenReader: _propTypes2.default.bool
};
exports.default = Label;
//# sourceMappingURL=Label.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Label/Label.js